import { isSameData, isSameList } from '../../models/dto/data-model-utils.js';
import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/data-model.js';
import { FormSubmission } from '../../models/serializable/form-submission/form-submission.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';


export class FormSubmissionsComponent extends Component {
  static readonly TYPE_ID: string = '88b176ec911d45f581a38e1a9406fdd8';

  constructor(
    public readonly submissions: FormSubmission[],
  ) {
    super();
  }

  get $removable(): boolean {
    return true;
  }

  get $typeId(): string {
    return FormSubmissionsComponent.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): FormSubmissionsComponent {
    return new FormSubmissionsComponent(
        MapUtils.getList<FormSubmission>(map, 'submissions', (data) => context.fromData<FormSubmission>(data as SerializedData)),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'submissions': this.submissions.map((x) => context.toData(x)),
    };
  }

  clone(): this {
    return new FormSubmissionsComponent(
        this.submissions.map((x) => x.clone()),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameList(other.submissions, this.submissions, isSameData);
  }
}

export class FormSubmissionsComponentBuilder extends DataModelBuilder<FormSubmissionsComponent> {
  build(context: SerializationContext, map: SerializedData): FormSubmissionsComponent {
    return FormSubmissionsComponent.fromMap(context, map);
  }
}
